/* global Office, document */

import React from "react";
import { createRoot } from "react-dom/client";
import { msalInstance } from "../auth/msalInstance";
import App from "./App";

Office.onReady(async () => {
  // MSAL v3+ requires initialize() before any auth calls
  await msalInstance.initialize();

  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
});
